'use client'
import React from 'react'
import styles from './styles.module.scss'

const PageTab: React.FC<{
  children: React.ReactNode
  withTabs?: boolean
}> = ({ children, withTabs = true }) => {
  return (
    <div className={`${styles.container} ${withTabs ? styles.withTabs : ''}`}>
      {children}
    </div>
  )
}

export default PageTab
